import {
  DefaultDetailCardItemData,
  DetailCardItemData,
  DetailCardItemsPropsType,
  LocationDetailCardItemData,
  TelephoneDetailCardItemData,
} from '@/common/components/DetailCard/DetailCard.types.ts';
import DefaultDetailCardItem from '@/common/components/DetailCard/items/DefaultDetailCardItem.tsx';
import TelephoneDetailCardItem from '@/common/components/DetailCard/items/TelephoneDetailCardItem.tsx';
import LocationDetailCardItem from '@/common/components/DetailCard/items/locationDetailCardItem/LocationDetailCardItem.tsx';
import { Box } from 'styled-system/jsx';

export default ({ items, ...rest }: DetailCardItemsPropsType) => {
  const generateItem = (item: DetailCardItemData) => {
    const data = { ...rest, ...item };
    const items = {
      default: (
        <DefaultDetailCardItem
          {...(data as Omit<DefaultDetailCardItemData, 'value'> & {
            value: string;
          })}
        />
      ),
      tel: (
        <TelephoneDetailCardItem
          {...(data as Omit<TelephoneDetailCardItemData, 'value'> & {
            value: string;
          })}
        />
      ),
      location: (
        <LocationDetailCardItem
          {...(data as Omit<LocationDetailCardItemData, 'value'> & {
            value: string;
          })}
        />
      ),
    };
    return items[item.type ?? 'default'];
  };
  return items.flatMap((item) => {
    if (item.value) {
      return (
        <Box key={item.keyName} my={8}>
          {generateItem(item)}
        </Box>
      );
    } else return [];
  });
};
